import React from "react";
import {TimeTrackerTicketsPage} from "./TimeTrackerTicketsPage";
import {useTimeTrackerTickets} from "./useTimeTrackerTickets";

function TimeTrackerTickets() {
  return <TimeTrackerTicketsPage {...useTimeTrackerTickets()} />;
}

export default TimeTrackerTickets;
